"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeTimestamps = void 0;
function makeTimestamps(wrap = false) {
    // TODO: change to maps
    let lastIndices = [-1, -1, -1, -1]; //EEG, PPG, Acc, Gyro
    let lastTimestamps = [-1, -1, -1, -1]; //EEG, PPG, Acc, Gyro
    return function (eventIndex, samplingRate, nSamples, stream) {
        const delta = 1000 * (1.0 / samplingRate) * nSamples;
        if (lastIndices[stream] === -1 || lastTimestamps[stream] === -1) {
            lastIndices[stream] = eventIndex;
            lastTimestamps[stream] = new Date().getTime() - delta;
        }
        // handle wrap around
        if (wrap) {
            while (lastIndices[stream] - eventIndex > 0x1000) {
                eventIndex += 0x10000;
            }
        }
        if (eventIndex === lastIndices[stream]) {
            return lastTimestamps[stream];
        }
        if (eventIndex > lastIndices[stream]) {
            lastTimestamps[stream] += delta * (eventIndex - lastIndices[stream]);
            lastIndices[stream] = eventIndex;
            return lastTimestamps[stream];
        }
        else {
            return lastTimestamps[stream] - delta * (lastIndices[stream] - eventIndex);
        }
    };
}
exports.makeTimestamps = makeTimestamps;
//# sourceMappingURL=time.js.map